import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GceManagementService } from '../../../services/gce-management.service';
import { LoaderService } from '../../../loader/loader.service';
import { AlertDialogService } from '../../../services/alert-dialog.service';
import { Confirm } from "../../../dialogs/confirm-dialog/confirm-dialog.component";
import { GcePerformanceCalculationDetail } from '../../../entities/gce-management/gce-performance-calculation-detail';
import { GcePerformanceCalculationDetracts } from '../../../entities/gce-management/gce-performance-calculation-detracts';
import * as moment from "moment";
import "moment-timezone";
import { GceInvoiceDms, GceClinic, GceInvoicePerson, GceInvoicePersonClinic } from '../../../entities/gce-management';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const tz = "Europe/Rome";
const dateFormat = "YYYY-MM-DDTHH:mm:ss";

const dateFormatDate = "YYYY-MM-DD";
const dateFormatHour = "HH:mm";

@Component({
  selector: 'app-gce-dialog-invoice-dms-form',
  templateUrl: './gce-dialog-invoice-dms-form.component.html',
  styleUrls: ['./gce-dialog-invoice-dms-form.component.css']
})
export class GceDialogInvoiceDmsFormComponent implements OnInit {
  invoice: GceInvoiceDms = null;
  oldinvoice: GceInvoiceDms = null;
  role: string;
  submitted: boolean = false;
  form: FormGroup;
  isAdmin: boolean = false;
  usr: any;
  nerr: number = 0;
  nop: number = 0;
  isNew: boolean = false;
  clinics: any[] = [];
  medics: any[] = [];
  medicsAll: any[] = [];
  isPersonWithError: boolean = false;


  constructor(public dialogRef: MatDialogRef<GceDialogInvoiceDmsFormComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private gceService: GceManagementService, private loaderService: LoaderService, private alertDialog: AlertDialogService,
    private fb: FormBuilder, private _sanitizer: DomSanitizer, private http: HttpClient) {
    this.invoice = data.invoice;

    this.role = data.role;
    this.usr = data.usr;
    this.nerr = data.nerr;
    if (data.isNew == true)
      this.isNew = true;
    if (data.clinics != null)
      this.clinics = data.clinics;
    if (data.medics != null)
      this.medicsAll = data.medics;
    console.log('INVOICE ON FORM %o', data);
    if (data.invoice != null && data.invoice.person != null) {
      this.isPersonWithError = data.invoice.person.errore;
    }
    else {
      this.isPersonWithError = true;
    }
    if (this.role != null && (this.role.toLowerCase() == 'amministratore' || this.role.toLowerCase() == 'amministratore dp' || this.role.toLowerCase() == 'hr medici')) {
      this.isAdmin = true;
      this.nop = data.nop;
    }

  }

  ngOnInit() {
    console.log('INIT isAdmin %o invoice %o', this.isAdmin, this.invoice);
    this.createForm();
    this.rebuildForm();
  }

  createForm() {
    this.form = new FormGroup(this.fb.group({
      mese: [''],
      idfatturazione: [''],
      ts_calcolo: [''],
      flg_conferma_hr: [''],
      user_conferma_hr: [''],
      ts_conferma_hr: [''],
      flg_cliniche_confermate: [''],
      idarea: [''],
      importo_fisso_dms_mensile_calc: [''],
      importo_fisso_dms_mensile_hr: [''],
      importo_target_produzione_mensile_area: [''],
      importo_produzione_mensile_area: [''],
      perc_produzione_mensile_area: [''],
      importo_bonus_dms_mensile_calc: [''],
      importo_bonus_dms_mensile_hr: [''],
      importo_target_mensile_personale: [''],
      importo_produzione_mensile_personale: [''],
      perc_produzione_mensile_personale: [''],
      importo_variabile_dms_mensile_calc: [''],
      importo_variabile_dms_mensile_hr: [''],
      importo_calcolo_old_trimestre: [''],
      importo_calcolo_new_trimestre: [''],
      importo_fatturato_l4l_area: [''],
      importo_extrabonus_dms_trimestrale_calc: [''],
      importo_extrabonus_dms_trimestrale_hr: [''],
      importo_target_fatturato_trimestre_area: [''],
      importo_fatturato_trimestre_area: [''],
      importo_variabile_dms_trimestre_calc: [''],
      importo_variabile_dms_trimestre_hr: [''],
      importo_target_produzione_trimestre_area: [''],
      importo_produzione_trimestre_area: [''],
      importo_bonus_dms_trimestre_calc: [''],
      importo_bonus_dms_trimestre_hr: [''],
      perc_produzione_trimestre_area: [''],
      gg_presenza_trimestre_calc: [''],
      gg_lavoro_trimestre : [''],
      gettone_giornaliero : [''],
      gg_recupero_trimestre_calc : [''],
      gg_ferie_utilizzo_trimestre : [''],
      gg_ferie_anno: [''],
      data_inizio_calcolo_ferie: [''],
      gg_ferie_utilizzate_precedenti : ['']
    }).controls, { updateOn: 'blur' });
    this.form.valueChanges.subscribe(x => {
      console.log('form value changed %o', x);
    })
  }

  encode(data: any) {
    var str = String.fromCharCode.apply(null, data);
    return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
  }

  bin2String(array: any) {
    var result = "";
    for (var i = 0; i < array.length; i++) {
      result += String.fromCharCode(parseInt(array[i], 2));
    }
    return result;
  }

  _arrayBufferToBase64(buffer: ArrayBuffer) {
    var binary;
    var len = buffer.byteLength;
    console.log('BUFFER %o BYTES %o LEN %o', buffer, len);
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(buffer[i]);
    }
    return window.btoa(binary);
  }

  rebuildForm() {
    console.log('REBUILD FORM invoice %o', this.invoice);
    let ts_calcolo = this.invoice.ts_calcolo;
    let ts_conferma_hr = this.invoice.ts_conferma_hr;
    var d = new Date(Date.now());

    if (this.isAdmin == true) {
      if (this.invoice.flg_conferma_hr == null || this.invoice.flg_conferma_hr == false)
        ts_conferma_hr = moment(d).format(dateFormat);
    }


    let my_importo_importo_fisso_dms_mensile_calc = Math.round(this.invoice.importo_fisso_dms_mensile_calc * 100) / 100;
    let my_importo_importo_fisso_dms_mensile_hr = Math.round(this.invoice.importo_fisso_dms_mensile_hr * 100) / 100;
    let my_importo_importo_target_produzione_mensile_area = Math.round(this.invoice.importo_target_produzione_mensile_area * 100) / 100;
    let my_importo_importo_produzione_mensile_area = Math.round(this.invoice.importo_produzione_mensile_area * 100) / 100;
    let my_importo_perc_produzione_mensile_area = Math.round(this.invoice.perc_produzione_mensile_area * 100) / 100;
    let my_importo_importo_bonus_dms_mensile_calc = Math.round(this.invoice.importo_bonus_dms_mensile_calc * 100) / 100;
    let my_importo_importo_bonus_dms_mensile_hr = Math.round(this.invoice.importo_bonus_dms_mensile_hr * 100) / 100;
    let my_importo_importo_target_mensile_personale = Math.round(this.invoice.importo_target_mensile_personale * 100) / 100;
    let my_importo_importo_produzione_mensile_personale = Math.round(this.invoice.importo_produzione_mensile_personale * 100) / 100;
    let my_importo_perc_produzione_mensile_personale = Math.round(this.invoice.perc_produzione_mensile_personale * 100) / 100;
    let my_importo_importo_variabile_dms_mensile_calc = Math.round(this.invoice.importo_variabile_dms_mensile_calc * 100) / 100;
    let my_importo_importo_variabile_dms_mensile_hr = Math.round(this.invoice.importo_variabile_dms_mensile_hr * 100) / 100;
    let my_importo_importo_calcolo_old_trimestre = Math.round(this.invoice.importo_calcolo_old_trimestre * 100) / 100;
    let my_importo_importo_calcolo_new_trimestre = Math.round(this.invoice.importo_calcolo_new_trimestre * 100) / 100;
    let my_importo_importo_fatturato_l4l_area = Math.round(this.invoice.importo_fatturato_l4l_area * 100) / 100;
    let my_importo_importo_extrabonus_dms_trimestrale_calc = Math.round(this.invoice.importo_extrabonus_dms_trimestrale_calc * 100) / 100;
    let my_importo_importo_extrabonus_dms_trimestrale_hr = Math.round(this.invoice.importo_extrabonus_dms_trimestrale_hr * 100) / 100;
    let my_importo_importo_target_fatturato_trimestre_area = Math.round(this.invoice.importo_target_fatturato_trimestre_area * 100) / 100;
    let my_importo_importo_fatturato_trimestre_area = Math.round(this.invoice.importo_fatturato_trimestre_area * 100) / 100;
    let my_importo_importo_variabile_dms_trimestre_calc = Math.round(this.invoice.importo_variabile_dms_trimestre_calc * 100) / 100;
    let my_importo_importo_variabile_dms_trimestre_hr = Math.round(this.invoice.importo_variabile_dms_trimestre_hr * 100) / 100;
    let my_importo_importo_target_produzione_trimestre_area = Math.round(this.invoice.importo_target_produzione_trimestre_area * 100) / 100;
    let my_importo_importo_produzione_trimestre_area = Math.round(this.invoice.importo_produzione_trimestre_area * 100) / 100;
    let my_importo_importo_bonus_dms_trimestre_calc = Math.round(this.invoice.importo_bonus_dms_trimestre_calc * 100) / 100;
    let my_importo_importo_bonus_dms_trimestre_hr = Math.round(this.invoice.importo_bonus_dms_trimestre_hr * 100) / 100;
    let my_importo_perc_produzione_trimestre_area = Math.round(this.invoice.perc_produzione_trimestre_area * 100) / 100;

    if (this.invoice.importo_fisso_dms_mensile_calc == null) my_importo_importo_fisso_dms_mensile_calc = null;
    if (this.invoice.importo_fisso_dms_mensile_hr == null) my_importo_importo_fisso_dms_mensile_hr = null;
    if (this.invoice.importo_target_produzione_mensile_area == null) my_importo_importo_target_produzione_mensile_area = null;
    if (this.invoice.importo_produzione_mensile_area == null) my_importo_importo_produzione_mensile_area = null;
    if (this.invoice.perc_produzione_mensile_area == null) my_importo_perc_produzione_mensile_area = null;
    if (this.invoice.importo_bonus_dms_mensile_calc == null) my_importo_importo_bonus_dms_mensile_calc = null;
    if (this.invoice.importo_bonus_dms_mensile_hr == null) my_importo_importo_bonus_dms_mensile_hr = null;
    if (this.invoice.importo_target_mensile_personale == null) my_importo_importo_target_mensile_personale = null;
    if (this.invoice.importo_produzione_mensile_personale == null) my_importo_importo_produzione_mensile_personale = null;
    if (this.invoice.perc_produzione_mensile_personale == null) my_importo_perc_produzione_mensile_personale = null;
    if (this.invoice.importo_variabile_dms_mensile_calc == null) my_importo_importo_variabile_dms_mensile_calc = null;
    if (this.invoice.importo_variabile_dms_mensile_hr == null) my_importo_importo_variabile_dms_mensile_hr = null;
    if (this.invoice.importo_calcolo_old_trimestre == null) my_importo_importo_calcolo_old_trimestre = null;
    if (this.invoice.importo_calcolo_new_trimestre == null) my_importo_importo_calcolo_new_trimestre = null;
    if (this.invoice.importo_fatturato_l4l_area == null) my_importo_importo_fatturato_l4l_area = null;
    if (this.invoice.importo_extrabonus_dms_trimestrale_calc == null) my_importo_importo_extrabonus_dms_trimestrale_calc = null;
    if (this.invoice.importo_extrabonus_dms_trimestrale_hr == null) my_importo_importo_extrabonus_dms_trimestrale_hr = null;
    if (this.invoice.importo_target_fatturato_trimestre_area == null) my_importo_importo_target_fatturato_trimestre_area = null;
    if (this.invoice.importo_fatturato_trimestre_area == null) my_importo_importo_fatturato_trimestre_area = null;
    if (this.invoice.importo_variabile_dms_trimestre_calc == null) my_importo_importo_variabile_dms_trimestre_calc = null;
    if (this.invoice.importo_variabile_dms_trimestre_hr == null) my_importo_importo_variabile_dms_trimestre_hr = null;
    if (this.invoice.importo_target_produzione_trimestre_area == null) my_importo_importo_target_produzione_trimestre_area = null;
    if (this.invoice.importo_produzione_trimestre_area == null) my_importo_importo_produzione_trimestre_area = null;
    if (this.invoice.importo_bonus_dms_trimestre_calc == null) my_importo_importo_bonus_dms_trimestre_calc = null;
    if (this.invoice.importo_bonus_dms_trimestre_hr == null) my_importo_importo_bonus_dms_trimestre_hr = null;
    if (this.invoice.perc_produzione_trimestre_area == null) my_importo_perc_produzione_trimestre_area = null;

    this.form.patchValue({
      importo_fisso_dms_mensile_calc: this.invoice.importo_fisso_dms_mensile_calc,
      importo_fisso_dms_mensile_hr: this.invoice.importo_fisso_dms_mensile_hr,
      importo_target_produzione_mensile_area: this.invoice.importo_target_produzione_mensile_area,
      importo_produzione_mensile_area: this.invoice.importo_produzione_mensile_area,
      perc_produzione_mensile_area: this.invoice.perc_produzione_mensile_area,
      importo_bonus_dms_mensile_calc: this.invoice.importo_bonus_dms_mensile_calc,
      importo_bonus_dms_mensile_hr: this.invoice.importo_bonus_dms_mensile_hr,
      importo_target_mensile_personale: this.invoice.importo_target_mensile_personale,
      importo_produzione_mensile_personale: this.invoice.importo_produzione_mensile_personale,
      perc_produzione_mensile_personale: this.invoice.perc_produzione_mensile_personale,
      importo_variabile_dms_mensile_calc: this.invoice.importo_variabile_dms_mensile_calc,
      importo_variabile_dms_mensile_hr: this.invoice.importo_variabile_dms_mensile_hr,
      importo_calcolo_old_trimestre: this.invoice.importo_calcolo_old_trimestre,
      importo_calcolo_new_trimestre: this.invoice.importo_calcolo_new_trimestre,
      importo_fatturato_l4l_area: this.invoice.importo_fatturato_l4l_area,
      importo_extrabonus_dms_trimestrale_calc: this.invoice.importo_extrabonus_dms_trimestrale_calc,
      importo_extrabonus_dms_trimestrale_hr: this.invoice.importo_extrabonus_dms_trimestrale_hr,
      importo_target_fatturato_trimestre_area: this.invoice. importo_target_fatturato_trimestre_area,
      importo_fatturato_trimestre_area: this.invoice.importo_fatturato_trimestre_area,
      importo_variabile_dms_trimestre_calc: this.invoice.importo_variabile_dms_trimestre_calc,
      importo_variabile_dms_trimestre_hr: this.invoice.importo_variabile_dms_trimestre_hr,
      importo_target_produzione_trimestre_area: this.invoice.importo_target_produzione_trimestre_area,
      importo_produzione_trimestre_area: this.invoice.importo_produzione_trimestre_area,
      importo_bonus_dms_trimestre_calc: this.invoice.importo_bonus_dms_trimestre_calc,
      importo_bonus_dms_trimestre_hr: this.invoice.importo_bonus_dms_trimestre_hr,
      perc_produzione_trimestre_area: this.invoice.perc_produzione_trimestre_area,
      gg_presenza_trimestre_calc:this.invoice.gg_presenza_trimestre_calc,
      gg_lavoro_trimestre : this.invoice.gg_lavoro_trimestre,
      gettone_giornaliero : this.invoice.gettone_giornaliero,
      gg_recupero_trimestre_calc : this.invoice.gg_recupero_trimestre_calc,
      gg_ferie_utilizzo_trimestre : this.invoice.gg_ferie_utilizzo_trimestre,
      gg_ferie_anno: this.invoice.gg_ferie_anno,
      data_inizio_calcolo_ferie: this.invoice.data_inizio_calcolo_ferie,
      gg_ferie_utilizzate_precedenti :this.invoice.gg_ferie_utilizzate_precedenti,
      mese: this.invoice.mese,
      idfatturazione: this.invoice.idfatturazione,
      ts_calcolo: this.invoice.ts_calcolo,
      flg_conferma_hr: this.invoice.flg_conferma_hr,
      user_conferma_hr: this.invoice.user_conferma_hr,
      ts_conferma_hr: this.invoice.ts_conferma_hr,
      flg_cliniche_confermate: this.invoice.flg_cliniche_confermate,
      idarea: this.invoice.idarea
    });

  }

  calcValuesForReport() {
    let hrm = false;
    /*
    if (!(this.invoice.importo_gettone_calc == null))
      this.invoice.importo_gettone_calc = Math.round(this.invoice.importo_gettone_calc * 100) / 100 || 0;
    if (!(this.invoice.importo_gettone_manuale == null))
      this.invoice.importo_gettone_manuale = Math.round(this.invoice.importo_gettone_manuale * 100) / 100 || 0;
    if (!(this.invoice.importo_direzione_calc == null))
      this.invoice.importo_direzione_calc = Math.round(this.invoice.importo_direzione_calc * 100) / 100 || 0;
    if (!(this.invoice.importo_direzione_manuale == null))
      this.invoice.importo_direzione_manuale = Math.round(this.invoice.importo_direzione_manuale * 100) / 100 || 0;
    if (!(this.invoice.importo_fisso_extra_calc == null))
      this.invoice.importo_fisso_extra_calc = Math.round(this.invoice.importo_fisso_extra_calc * 100) / 100 || 0;
    if (!(this.invoice.importo_prestazioni_calc == null))
      this.invoice.importo_prestazioni_calc = Math.round(this.invoice.importo_prestazioni_calc * 100) / 100 || 0;

    if (!(this.invoice.importo_integr_minimo_calc == null))
      this.invoice.importo_integr_minimo_calc = Math.round(this.invoice.importo_integr_minimo_calc * 100) / 100 || 0;
    if (!(this.invoice.importo_prestazioni_manuale == null))
      this.invoice.importo_prestazioni_manuale = Math.round(this.invoice.importo_prestazioni_manuale * 100) / 100 || 0;
    if (!(this.invoice.importo_riporto_mese_succ == null))
      this.invoice.importo_riporto_mese_succ = Math.round(this.invoice.importo_riporto_mese_succ * 100) / 100 || 0;

    if (!(this.invoice.importo_riporto_mese_prec == null))
      this.invoice.importo_riporto_mese_prec = Math.round(this.invoice.importo_riporto_mese_prec * 100) / 100 || 0;
    if (!(this.invoice.tot_fattura_prestazione == null))
      this.invoice.tot_fattura_prestazione = Math.round(this.invoice.tot_fattura_prestazione * 100) / 100 || 0;
    if (!(this.invoice.importo_prest_mediche_manuale == null))
      this.invoice.importo_prest_mediche_manuale = Math.round(this.invoice.importo_prest_mediche_manuale * 100) / 100 || 0;
    if (!(this.invoice.importo_prest_anastesista_manuale == null))
      this.invoice.importo_prest_anastesista_manuale = Math.round(this.invoice.importo_prest_anastesista_manuale * 100) / 100 || 0;

    if (!(this.invoice.importo_gettone_manuale_hr == null))
      this.invoice.importo_gettone_manuale_hr = Math.round(this.invoice.importo_gettone_manuale_hr * 100) / 100 || 0;
    if (!(this.invoice.importo_direzione_manuale_hr == null))
      this.invoice.importo_direzione_manuale_hr = Math.round(this.invoice.importo_direzione_manuale_hr * 100) / 100 || 0;
    if (!(this.invoice.importo_prestazioni_manuale_hr == null))
      this.invoice.importo_prestazioni_manuale_hr = Math.round(this.invoice.importo_prestazioni_manuale_hr * 100) / 100 || 0;

    if (!(this.invoice.importo_direzione__area_manuale_hr == null))
      this.invoice.importo_direzione__area_manuale_hr = Math.round(this.invoice.importo_direzione__area_manuale_hr * 100) / 100 || 0;
    if (!(this.invoice.importo_gettone_unitario_hr == null))
      this.invoice.importo_gettone_unitario_hr = Math.round(this.invoice.importo_gettone_unitario_hr * 100) / 100 || 0;
    if (!(this.invoice.importo_prest_mediche_manuale_hr == null))
      this.invoice.importo_prest_mediche_manuale_hr = Math.round(this.invoice.importo_prest_mediche_manuale_hr * 100) / 100 || 0;
    if (!(this.invoice.importo_prest_anastesista_manuale_hr == null))
      this.invoice.importo_prest_anastesista_manuale_hr = Math.round(this.invoice.importo_prest_anastesista_manuale_hr * 100) / 100 || 0;

    if (this.invoice.nota_riporto_mese_succ != null) {

      this.invoice.nota_riporto_mese_succ = this.invoice.nota_riporto_mese_succ.replace(/&#10;/g, '\n').replace(/&#9;/g, '\t').replace(/&#8364;/g, '€').replace(/&#34;/g, '"').replace(/&#232;/g, 'e\'').replace(/&#242;/g, 'o\'').replace(/&#224;/g, 'a\'').replace(/&#249;/g, 'u\'').replace(/&#236;/g, 'i\'');

    }

    if (this.invoice.note != null) {

      this.invoice.note = this.invoice.note.replace(/&#10;/g, '\n').replace(/&#9;/g, '\t').replace(/&#8364;/g, '€').replace(/&#34;/g, '"').replace(/&#232;/g, 'e\'').replace(/&#242;/g, 'o\'').replace(/&#224;/g, 'a\'').replace(/&#249;/g, 'u\'').replace(/&#236;/g, 'i\'');

    }

    if (this.invoice.note_hr != null) {

      this.invoice.note_hr = this.invoice.note_hr.replace(/&#10;/g, '\n').replace(/&#9;/g, '\t').replace(/&#8364;/g, '€').replace(/&#34;/g, '"').replace(/&#232;/g, 'e\'').replace(/&#242;/g, 'o\'').replace(/&#224;/g, 'a\'').replace(/&#249;/g, 'u\'').replace(/&#236;/g, 'i\'');

    }
*/
  }
  onChangeNull($event) {
    console.log('onChange null %o', $event);
  }

  save() {
    this.submitted = true;
    let formData = this.form.getRawValue();

    if (formData['note_hr'] != null)
      formData['note_hr'] = this._sanitizer.sanitize(SecurityContext.HTML, formData['note_hr']);
    if (formData['note'] != null)
      formData['note'] = this._sanitizer.sanitize(SecurityContext.HTML, formData['note']);
    if (formData['nota_riporto_mese_succ'] != null)
      formData['nota_riporto_mese_succ'] = this._sanitizer.sanitize(SecurityContext.HTML, formData['nota_riporto_mese_succ']);
    console.log('ts_conferma_clinica BEFORE %o and %o', formData, this.form.value.importo_prestazioni_manuale);

    //check dates

    if (this.form.valid) {
      if (window.confirm('Sei sicuro di voler salvare la liquidazione?')) {
        var d = new Date(Date.now());
        this.loaderService.show();
        //get user info, parsing the profile
        //rec
        //hr
        if (this.isAdmin == true) {
          if (formData['flg_conferma_hr'] == true) {
            formData['user_conferma_hr'] = this.usr;
            if (formData['ts_conferma_hr'] == null) {
              formData['ts_conferma_hr'] = moment(d).format(dateFormat);
            }
            if (formData['flg_conferma_clinica'] == false) {
              formData['flg_conferma_clinica'] = true;
              formData['ts_conferma_clinica'] = moment(d).format(dateFormat);
              formData['user_conferma_clinica'] = this.usr;
            }
          }
          else {
            formData['user_conferma_hr'] = '';
            formData['flg_conferma_clinica'] = false;
          }
        }
        else {
          if (formData['flg_conferma_clinica'] == true) {
            formData['user_conferma_clinica'] = this.usr;
            if (formData['ts_conferma_clinica'] == null) {
              formData['ts_conferma_clinica'] = moment(d).format(dateFormat);
            }
          }
          else {
            formData['user_conferma_clinica'] = '';
          }
        }

        console.log('FORMDATA for update %o', formData);

        this.gceService.updateInvoiceDms(formData).subscribe((result: GceInvoiceDms) => {
          //this.loaderService.hide();
          this.submitted = false;
          result.person = this.invoice.person;
          this.invoice = result;
          //update 
          this.gceService.calculateBillingDoctor(formData['cod_clinica'], formData['idfatturazione'], this.gceService.dataRepoGceEnvironment.getToDate()).subscribe(r => {
            console.log('after recalculate save %o', r);
            this.loaderService.show();
            this.dialogRef.close({ saved: true, invoice: result });
          }, err => {
            this.loaderService.show();
          });
        }, err => {
          this.loaderService.show();
        });
      }
    }
  }

  resend() {
    console.log('resend');
  }


  confirmT() {
    console.log('confirmT');
  }


  nullinvoice() {
    console.log('nullInvoice');
  }

  cancel() {
    this.dialogRef.close({ saved: false });
  }

  meseChange(event) {

  }
}
